import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { deepCompare } from "@website/utils/deep-compare";
import { HotelFilterChipsPropertiesTypes } from "@website/widget/filter/hotel-filter-chips/hotel-filter-chips.types";
import { useHotelFiltersChips } from "@website/widget/filter/hotel-filter-chips/hotel-filters-chips.hook";
import { useRouter } from "next/router";
import { Children, Fragment, memo } from "react";
import { FormProvider } from "react-hook-form";

const Component = <T extends Record<string, unknown>>(
  properties: HotelFilterChipsPropertiesTypes<T>
) => {
  const router = useRouter();

  const {
    filtersSchemaEntries,
    children,
    methods,
    onClick,
    onClose,
    onSubmit,
    onReset
  } = useHotelFiltersChips(properties);

  return (
    <div className={`${properties?.classname} relative flex flex-row gap-2`}>
      {filtersSchemaEntries?.map(([key, values]) => (
        <Button
          EndIcon={
            (
              key === "price_range"
                ? router?.query["price_from"] || router?.query?.["price_to"]
                : router?.query?.[key]
            ) ? (
              <MaterialIcon
                className="text-body-1 relative z-[9] cursor-pointer"
                name="cancel"
                onClick={(event) =>
                  onClose(
                    key === "price_range" ? ["price_from", "price_to"] : [key],
                    event
                  )
                }
                variant="fill"
              />
            ) : undefined
          }
          className="!whitespace-nowrap"
          color={
            (
              key === "price_range"
                ? router?.query["price_from"] || router?.query?.["price_to"]
                : router?.query?.[key]
            )
              ? "secondary"
              : "neutral"
          }
          onClick={onClick.bind(null, [key])}
          size="small"
          text={values?.["title"]}
          variant="round-outline"
        />
      ))}
      <MiniPopover
        defaultHorizontalPosition="start"
        className={`shadow-2 overflow-hidden rounded-xl ${
          router?.query["popover"] === "facilities" ? "lg:!w-[440px]" : ""
        }`}
        onClose={() => onClose([])}
        open={Boolean(router?.query["popover"])}
        title={
          children?.filter(
            (child) => child?.key === router?.query["popover"]
          )?.[0]?.props?.title
        }
      >
        <div className="flex !w-full flex-col px-4 pb-4">
          <FormProvider {...methods}>
            {Children.map(children, (child, index) => (
              <Fragment key={child?.key ?? index}>
                {child?.key === router?.query?.["popover"] && child}
              </Fragment>
            ))}
          </FormProvider>
          <div className="flex w-full flex-row items-center justify-between">
            <Button
              className="w-[140px]"
              color="secondary"
              onClick={onReset}
              text="حذف فیلترها"
              variant="text"
              disabled={
                router?.query["popover"] === "price_range"
                  ? !Object?.keys(router?.query)?.includes(
                      String("price_from")
                    ) &&
                    !Object?.keys(router?.query)?.includes(String("price_to"))
                  : !Object?.keys(router?.query)?.includes(
                      String(router?.query["popover"])
                    )
              }
            />
            <Button
              className="w-[140px]"
              color="secondary"
              onClick={onSubmit}
              text="اعمال"
              variant="contained"
            />
          </div>
        </div>
      </MiniPopover>
    </div>
  );
};

export const HotelFilterChips = memo(Component, deepCompare);
